import {
  Component,
  ViewEncapsulation
} from '@angular/core';

import { CopyBase } from '../copy-base';
import { CopyService } from '../copy-service/copy.service';

/**
 * Inline Copy component
 *
 * Usage:
 * <code><pre>
 * // Individual module import
 * import { InlineCopyModule } from 'patternfly-ng/copy';
 * // Or
 * import { InlineCopyModule } from 'patternfly-ng';
 *
 * &#64;NgModule({
 *   imports: [InlineCopyModule,...]
 * })
 * export class AppModule(){}
 * </pre></code>
 *
 * Optional:
 * <code><pre>
 * import { CopyEvent } from 'patternfly-ng/copy';
 * </pre></code>
 */

export class InlineCopyComponent extends CopyBase {
  /**
   * The default constructor
   */
  constructor(protected copyService: CopyService) {
    super(copyService);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  encapsulation: ViewEncapsulation.None,
  selector: 'pfng-inline-copy',
  template: `<span [ngStyle]="{'width': width}" class="pfng-inline-copy"><span class="pfng-inline-copy-body"><input type="text" tabindex="-1" [value]="value" class="pfng-inline-copy-txt-cont" [tooltip]="tooltipText" [placement]="tooltipPlacement" container="body" readonly="readonly"> </span><button type="button" class="pfng-inline-copy-btn" [tooltip]="copyBtnTooltipText" [placement]="copyBtnTooltipPlacement" triggers="hover" container="body" [attr.aria-label]="buttonAriaLabel" (click)="copy()"><i class="fa" [ngClass]="{'fa-check': recentlyCopied, 'fa-clipboard': !recentlyCopied}" aria-hidden="true"></i></button></span>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: CopyService, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
